<template>
  <v-row class="my-10 px-5 py-4 justify-center">
    <p>{{ text[locale][type] }}</p>
    <canvas id="canvas"></canvas>
  </v-row>
</template>

<script>
export default {
  name: "MiniMap",
  props: {
    type: String,
    level: String,
    skill: String,
    locale: String
  },
  data() {
    return {
      context: {},
      image: null,
      levelMap: {
        a1: 0,
        a2: 1,
        b1: 2,
        b2: 3,
        c1: 4,
        c2: 5
      },
      skillMap: {
        samtala: 0,
        beratta: 1,
        lyssna: 2,
        skriva: 3,
        lasa: 4
      },

      nivMap: {
        a1: 0,
        a2: 0,
        b1: 1,
        b2: 1,
        c1: 2,
        c2: 2
      },
	top: {
		sv: ["basnivå","självständig nivå","avancerad nivå"],
		en: ["basic level","independent level", "advanced level"],
		ar: ["basic level","independent level", "advanced level"]
	},
	skillText: {
		sv: ["samtala", "berätta & presentera", "lyssna", "skriva", "läsa"],
		en: ["conversation", "informing & presenting", "listening", "writing", "reading"],
		ar: ["conversation", "informing & presenting", "listening", "writing", "reading"]
	},
	levelText: {
		sv: ["a1","a2","b1","b2","c1","c2"],
		en: ["a1","a2","b1","b2","c1","c2"],
		ar: ["a1","a2","b1","b2","c1","c2"]
	},
      text: {
        sv: {
          D3:
            "Ni kommer nu att bedöma den markerade färdigheten och nivån.",
          D1: "Du kommer nu att bedöma den markerade färdigheten och nivån."
        },
        en: {
          D3: "You will now assess the marked skill and level.",
          D1: "You will now assess the marked skill and level."
        },
        ar: {
          D3: "ستقوم الآن بتقييم الكفاءات المشار اليها والمستوى",
          D1: "ستقوم الآن بتقييم الكفاءات المشار اليها والمستوى"
        }
      }
    };
  },
  computed: {
    width() {
      const c = document.getElementById("canvas");
      return c.width;
    },
    height() {
      const c = document.getElementById("canvas");
      return c.height;
    }
  },
  methods: {
	  Draw(){
      this.context.clearRect(0, 0, this.width, this.height);
      const w1 = this.width / 4;
      const w2 = w1 / 2;
      const h1 = this.height / 7;
      const darkGreen = "#B8BE14";
      const lightGreen = "#E1E17C";

      this.context.fillStyle = lightGreen;

      this.context.strokeRect(
        0 + 0.5,
        0 + 0.5,
        this.width - 0.5,
        this.height - 0.5
      );

		  this.context.fillStyle = lightGreen;
      this.context.fillRect(
        0,
        h1 * 2 + h1 * this.skillMap[this.skill] + 0.5,
        this.width - 1,
        h1 - 0.5
      );
      this.context.fillRect(w1 + w1 * this.nivMap[this.level], 0, w1, h1);
      this.context.fillRect(w1 + w2 * this.levelMap[this.level], h1, w2, h1);

      this.context.fillStyle = darkGreen;
      this.context.fillRect(
        w1 + 0.5 + w2 * this.levelMap[this.level],
        h1 * 2 + h1 * this.skillMap[this.skill] + 0.5,
        w2 - 1,
        h1 - 0.5
      );

      this.context.fillStyle = "#000000";

      for (let x = 0; x < 4; x++) {
        this.context.strokeRect(w1 + x * w1, 0, w1, h1);
      }

      this.context.font = "14px Roboto";

      

      /*if( this.locale == 'ar') {

        let textSize = this.context.measureText(this.top[this.locale][0]);
      this.context.fillText(
        this.top[this.locale][0].toUpperCase(),
        w1 + w1 / 1 - textSize.width / 1,
        h1 / 2 + textSize.actualBoundingBoxAscent / 2
      );

      textSize = this.context.measureText(this.top[this.locale][1]);
      this.context.fillText(
        this.top[this.locale][1].toUpperCase(),
        w1 * 2 + w1 - textSize.width / 2,
        h1 / 2 + textSize.actualBoundingBoxAscent / 2
      );

        textSize = this.context.measureText(this.top[this.locale][2]);
        this.context.fillText(
          this.top[this.locale][2].toUpperCase(),
          w1 * 3 + w1 / 1 - textSize.width / 1.6,
          h1 / 2 + textSize.actualBoundingBoxAscent / 2
        );

        for (let x = 0; x < 6; x++) {
        this.context.strokeRect(w1 + x * w2, h1, w2, h1);
        this.context.font = "15px Roboto";
        this.context.fillText(
          this.levelText[this.locale][x].toUpperCase(),
          w1 * 1.3 + x * w2,
          h1 * 1.6
        );
      }

      for (let x = 0; x < 5; x++) {
        this.context.strokeRect(0, h1 * 2 + x * h1, w1, h1);
        this.context.font = "15px Roboto";
        this.context.textAlign = "left";
        this.context.fillText(
          this.skillText[this.locale][x].toUpperCase(),
          w1 * 0.05,
          h1 * 2 * 1.3 + x * h1
        );
      }
      } else {
*/
        let textSize = this.context.measureText(this.top[this.locale][0]);
        this.context.textAlign = "left";
      this.context.fillText(
        this.top[this.locale][0].toUpperCase(),
        w1 + w1 / 2 - textSize.width / 1.6,
        h1 / 2 + textSize.actualBoundingBoxAscent / 2
      );

      textSize = this.context.measureText(this.top[this.locale][1]);
      this.context.fillText(
        this.top[this.locale][1].toUpperCase(),
        w1 * 2 + w1 / 2 - textSize.width / 1.6,
        h1 / 2 + textSize.actualBoundingBoxAscent / 2
      );

        textSize = this.context.measureText(this.top[this.locale][2]);
        this.context.fillText(
          this.top[this.locale][2].toUpperCase(),
          w1 * 3 + w1 / 2 - textSize.width / 1.6,
          h1 / 2 + textSize.actualBoundingBoxAscent / 2
        );
        this.context.textAlign = "right";
        for (let x = 0; x < 6; x++) {
          
        this.context.strokeRect(w1 + x * w2, h1, w2, h1);
        this.context.font = "15px Roboto";
        this.context.fillText(
          this.levelText[this.locale][x].toUpperCase(),
          w1 * 1.3 + x * w2,
          h1 * 1.6
        );
      }
this.context.textAlign = "left";
      for (let x = 0; x < 5; x++) {
        this.context.strokeRect(0, h1 * 2 + x * h1, w1, h1);
        this.context.font = "15px Roboto";
        this.context.fillText(
          this.skillText[this.locale][x].toUpperCase(),
          w1 * 0.05,
          h1 * 2 * 1.3 + x * h1
        );
      }
      //}

      
    },
  },
  watch: {
    level: {
      handler: function() {
        this.Draw();
      },
      deep: true
    },
    skill: {
	    handler: function() {
      		this.Draw();
	    },
	    deep: true
    },
    locale: {
	    handler: function() {
      		this.Draw();
	    },
	    deep: true
    },
  },
  mounted() {
    const dpi = window.devicePixelRatio;
    const c = document.getElementById("canvas");

    const styleHeight = +getComputedStyle(c)
      .getPropertyValue("height")
      .slice(0, -2);
    const styleWidth = +getComputedStyle(c)
      .getPropertyValue("width")
      .slice(0, -2);

    c.setAttribute("height", styleHeight * dpi);
    c.setAttribute("width", styleWidth * dpi);
    this.context = c.getContext("2d");
    this.Draw();
  }
};
</script>

<style>
#canvas {
  width: 100%;
  height: auto;
}
</style>
